export default "__VITE_ASSET__C_DyQsUl__"